// @ts-nocheck
import React from 'react';
import { MachineForm } from './MachineForm';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Cog } from 'lucide-react';
import { ModalBreadcrumbHeader } from '@/components/shared/ModalBreadcrumbHeader';

export interface MachineFormModalProps {
  open?: boolean;
  onClose?: () => void;
  onSuccess?: (newItem: { id: string; label: string; original?: any }) => void;
  onCancel?: () => void;
  machineId?: string;
  mode?: 'create' | 'edit';
  initialData?: any;
  breadcrumb?: string[];
}

function cleanMachineBreadcrumbs(crumbs?: string[], fallback = 'Thiết bị'): string[] {
  if (!crumbs || crumbs.length === 0) return [fallback];
  const mapped = crumbs.map((c) => {
    if (c === 'Thêm mới thiết bị' || c === 'Thêm thiết bị mới' || c === 'Cập nhật thiết bị') return 'Thiết bị';
    return c;
  });
  return mapped.filter((c, i) => i === 0 || c !== mapped[i - 1]);
}

export default function MachineFormModal({
  open,
  onClose,
  onSuccess,
  onCancel,
  machineId,
  mode,
  initialData,
  breadcrumb,
}: MachineFormModalProps) {
  const isEdit = !!machineId || mode === 'edit';

  const handleClose = () => {
    if (onCancel) onCancel();
    if (onClose) onClose();
  };

  const handleSuccess = (newItem: { id: string; label: string; original?: any }) => {
    if (onSuccess) {
      onSuccess(newItem);
    }
    if (onClose) onClose();
  };

  const content = (
    <div className="space-y-3">
      <DialogHeader className="sr-only">
        <DialogTitle>{isEdit ? 'Cập nhật Thiết bị' : 'Thêm mới Thiết bị'}</DialogTitle>
      </DialogHeader>

      <ModalBreadcrumbHeader
        breadcrumbs={cleanMachineBreadcrumbs(breadcrumb, isEdit ? 'Cập nhật thiết bị' : 'Thêm mới thiết bị')}
        title={isEdit ? 'Cập nhật thiết bị' : 'Thêm mới thiết bị'}
        icon={Cog}
        iconColor="text-indigo-600"
      />

      <div className="pt-2">
        <MachineForm
          isModal={true}
          machineId={machineId}
          initialData={initialData}
          onSuccess={handleSuccess}
          onCancel={handleClose}
          submitLabel={isEdit ? 'Cập nhật máy' : 'Tạo mới thiết bị'}
        />
      </div>
    </div>
  );

  // When used as standalone modal with explicit open/onClose
  if (open !== undefined && onClose !== undefined) {
    return (
      <Dialog open={open} onOpenChange={(val) => !val && handleClose()}>
        <DialogContent className="w-[95vw] sm:max-w-3xl md:max-w-4xl lg:max-w-4xl xl:max-w-5xl max-h-[92vh] overflow-y-auto p-4 sm:p-6">
          {content}
        </DialogContent>
      </Dialog>
    );
  }

  // When embedded in ComboboxFK which supplies its own Dialog
  return content;
}

export { MachineFormModal };
